import React, { useState } from 'react';
import './Summary.css';
import PasswordModal from './PasswordModal';

const Summary = () => {
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  const handlePDFClick = (e) => {
    e.preventDefault();
    setShowPasswordModal(true);
  };

  const handlePasswordSuccess = () => {
    setShowPasswordModal(false);
    window.open('/presentation.pdf', '_blank');
  };
  return (
    <div className="summary-container">
      <div className="summary-header">
        <h1>Turintech Presentation Materials</h1>
        <p className="subtitle">Artemis Intelligence Platform & evoML</p>
      </div>

      <div className="summary-section">
        <h2>Presentation Resources</h2>
        <div className="resource-item">
          <h3>Slide Deck</h3>
          <p>
            <a href="#" onClick={handlePDFClick} className="resource-link">
              📄 View Presentation PDF
            </a>
          </p>
        </div>
        
        <div className="resource-item">
          <h3>Interactive Applications</h3>
          <ul>
            <li>
              <a href="https://presentationturintech.ngrok.app/" target="_blank" rel="noopener noreferrer" className="resource-link">
                Interactive app with deeper research, demos, and background about Turintech approaches
              </a>
            </li>
            <li>
              <a href="https://usecases.ngrok.app/" target="_blank" rel="noopener noreferrer" className="resource-link">
                Estimated cost savings and real performance gains in real world popular code bases
              </a>
            </li>
            <li>
              <a href="https://www.turintech.ai/developer" target="_blank" rel="noopener noreferrer" className="resource-link">
                Turintech Developer Portal
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="summary-section">
        <h2>Artemis-Powered Demos</h2>
        <div className="demo-grid">
          <div className="demo-item">
            <h4>evoML + Artemis Intelligence</h4>
            <p>Automatic Feature Discovery and Engineering</p>
            <a href="https://youtu.be/RITDizTXbeM" target="_blank" rel="noopener noreferrer" className="demo-link">
              Watch Demo →
            </a>
          </div>
          
          <div className="demo-item">
            <h4>SAS to Python Translation</h4>
            <p>Translating models written in SAS to Python with Artemis</p>
            <a href="https://youtu.be/tnvNnljFve0" target="_blank" rel="noopener noreferrer" className="demo-link">
              Watch Demo →
            </a>
          </div>
          
          <div className="demo-item">
            <h4>Prompt & Model Optimization</h4>
            <p>Extracting & optimising prompts/models in Google's financial sample agent</p>
            <a href="https://youtu.be/ZRSE2UtgYAE" target="_blank" rel="noopener noreferrer" className="demo-link">
              Watch Demo →
            </a>
          </div>
          
          <div className="demo-item">
            <h4>Artemis Intelligence Compliance</h4>
            <p>Compliance and governance features</p>
            <a href="https://youtu.be/PQIBgnT2Whw" target="_blank" rel="noopener noreferrer" className="demo-link">
              Watch Demo →
            </a>
          </div>
          
          <div className="demo-item">
            <h4>Artemis Intelligence Apps</h4>
            <p>Application development capabilities</p>
            <a href="https://youtu.be/5nEdw_dQQ8s" target="_blank" rel="noopener noreferrer" className="demo-link">
              Watch Demo →
            </a>
          </div>
          
          <div className="demo-item">
            <h4>GitHub Copilot to Artemis</h4>
            <p>Optimising AI-Generated Code</p>
            <a href="https://www.youtube.com/watch?v=41aTVjE_H0M" target="_blank" rel="noopener noreferrer" className="demo-link">
              Watch Demo →
            </a>
          </div>
          
          <div className="demo-item">
            <h4>FullFIX Library Optimization</h4>
            <p>How We Made the FullFIX Library Faster with Artemis</p>
            <a href="https://www.youtube.com/watch?v=ZQkgV81O3uQ" target="_blank" rel="noopener noreferrer" className="demo-link">
              Watch Demo →
            </a>
          </div>
        </div>
      </div>

      <div className="summary-section">
        <h2>evoML Integration Demos</h2>
        <div className="integration-list">
          <div className="integration-item">
            <span className="integration-name">evoML + Gemini Code Assist</span>
            <a href="https://youtu.be/tUX6pjh2pzg" target="_blank" rel="noopener noreferrer" className="integration-link">
              View →
            </a>
          </div>
          
          <div className="integration-item">
            <span className="integration-name">evoML + Gemini CLI</span>
            <a href="https://youtu.be/dOezAjhsrZg" target="_blank" rel="noopener noreferrer" className="integration-link">
              View →
            </a>
          </div>
          
          <div className="integration-item">
            <span className="integration-name">evoML + GitHub Copilot</span>
            <a href="https://youtu.be/hgn1Jk8LoLE" target="_blank" rel="noopener noreferrer" className="integration-link">
              View →
            </a>
          </div>
          
          <div className="integration-item">
            <span className="integration-name">evoML + Cursor</span>
            <a href="https://youtu.be/JfLb2O3X39s" target="_blank" rel="noopener noreferrer" className="integration-link">
              View →
            </a>
          </div>
          
          <div className="integration-item">
            <span className="integration-name">evoML + Claude Code</span>
            <a href="https://youtu.be/XTFyMiUJ_iA" target="_blank" rel="noopener noreferrer" className="integration-link">
              View →
            </a>
          </div>
          
          <div className="integration-item">
            <span className="integration-name">evoML + Agent Development Kit</span>
            <a href="https://youtu.be/lCZ_CwzEIQ8" target="_blank" rel="noopener noreferrer" className="integration-link">
              View →
            </a>
          </div>
        </div>
      </div>


      <div className="summary-section">
        <h2>Architecture & Deployment</h2>
        <div className="deployment-content">
          <p>
            For a deep dive into our deployment architecture—including the security-scanning tools 
            that keep Docker images current and the cloud services we leverage—see:
          </p>
          <ul>
            <li>
              <a href="https://docs.artemis.turintech.ai/deployment/deployment-options" target="_blank" rel="noopener noreferrer" className="resource-link">
                Artemis Deployment Documentation
              </a>
            </li>
            <li>
              <a href="https://docs.evoml.ai/" target="_blank" rel="noopener noreferrer" className="resource-link">
                evoML Documentation
              </a>
            </li>
          </ul>
          <p className="note">
            We have extensive experience running Artemis in highly secure, isolated environments; 
            notably, we recently delivered a fully isolated Google Cloud deployment for another major institution.
          </p>
        </div>
      </div>
      
      <PasswordModal
        isOpen={showPasswordModal}
        onClose={() => setShowPasswordModal(false)}
        onSuccess={handlePasswordSuccess}
        title="Protected Document"
      />
    </div>
  );
};

export default Summary;